import { apiService } from "./api";

export const notificationService = {
  // Get all notifications
  getNotifications: async (params = {}) => {
    try {
      const { skip = 0, limit = 100, unread_only = false } = params;
      const response = await apiService.get("/notifications", {
        params: { skip, limit, unread_only },
      });

      // Ensure we always return an array
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error("Error fetching notifications:", error);

      // For development, return mock data if API fails
      if (process.env.NODE_ENV === "development") {
        console.warn("Using mock notification data for development");
        return notificationService._getMockNotifications();
      }

      throw new Error(`Failed to fetch notifications: ${error.message}`);
    }
  },

  // Mark notification as read
  markAsRead: async (notificationId) => {
    try {
      const response = await apiService.post(
        `/notifications/${notificationId}/read`
      );
      return response.data;
    } catch (error) {
      console.error("Error marking notification as read:", error);
      throw new Error(`Failed to mark notification as read: ${error.message}`);
    }
  },

  // Delete notification
  deleteNotification: async (notificationId) => {
    try {
      await apiService.delete(`/notifications/${notificationId}`);
      return true;
    } catch (error) {
      console.error("Error deleting notification:", error);
      throw new Error(`Failed to delete notification: ${error.message}`);
    }
  },

  // Get unread count - IMPROVED METHOD
  getUnreadCount: async () => {
    try {
      // Try to get unread count from dedicated endpoint first
      try {
        const response = await apiService.get("/notifications/unread-count");
        return response.data.unread_count || 0;
      } catch (endpointError) {
        // Fallback to fetching unread notifications and counting
        const notifications = await notificationService.getNotifications({
          unread_only: true,
        });
        return notifications.length;
      }
    } catch (error) {
      console.error("Error getting unread count:", error);
      return 0;
    }
  },

  // CREATE TEST NOTIFICATION - Real API call
  createTestNotification: async (type = "order_update") => {
    try {
      const response = await apiService.post(
        "/notifications/test-notification",
        {
          notification_type: type,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating test notification:", error);

      // Return mock data for testing if API fails
      const testNotifications = {
        order_update: {
          title: "Order Status Updated",
          message:
            "Order ORD-123456 has been assigned to a medical professional",
          type: "info",
          priority: "medium",
        },
        new_order: {
          title: "New Order Created",
          message: "A new order has been created and requires assignment",
          type: "success",
          priority: "high",
        },
        route_optimized: {
          title: "Route Optimized",
          message: "Route for today has been optimized and updated",
          type: "info",
          priority: "low",
        },
        system_alert: {
          title: "System Maintenance",
          message: "Scheduled maintenance will occur tonight at 2 AM EST",
          type: "warning",
          priority: "medium",
        },
      };

      return testNotifications[type] || testNotifications.order_update;
    }
  },

  // MOCK DATA for development
  _getMockNotifications: () => {
    const now = new Date();
    return [
      {
        id: 1,
        title: "New Order Created",
        message: "Order ORD-250801-001 has been created for John Doe",
        type: "info",
        priority: "medium",
        is_read: false,
        created_at: new Date(now.getTime() - 5 * 60 * 1000).toISOString(), // 5 minutes ago
        user_id: 1,
        order_id: 123,
      },
      {
        id: 2,
        title: "Order Status Updated",
        message: "Order ORD-250801-002 has been assigned to Dr. Smith",
        type: "success",
        priority: "high",
        is_read: false,
        created_at: new Date(now.getTime() - 15 * 60 * 1000).toISOString(), // 15 minutes ago
        user_id: 1,
        order_id: 124,
      },
      {
        id: 3,
        title: "Route Optimized",
        message: "Today's routes have been optimized for maximum efficiency",
        type: "info",
        priority: "low",
        is_read: true,
        created_at: new Date(now.getTime() - 60 * 60 * 1000).toISOString(), // 1 hour ago
        user_id: 1,
      },
      {
        id: 4,
        title: "System Maintenance",
        message: "Scheduled maintenance tonight at 2 AM EST",
        type: "warning",
        priority: "high",
        is_read: false,
        created_at: new Date(now.getTime() - 2 * 60 * 60 * 1000).toISOString(), // 2 hours ago
        user_id: 1,
      },
    ];
  },
};